export default __webpack_public_path__ + "static/media/img-industry-smart-workplace.dac9e049.svg";